import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import { startsWith } from 'components/common/utils';
import { DELETE_OEM_ERROR_CODE, FETCH_OEM_ERROR_CODE, GET_OEM_ERROR_CODE } from 'actions/oemErrorCode';
import OemErrorCodeForm from './OemErrorCodeForm';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';

const OemErrorCodeList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [allOemErrorCodeData, setAllOemErrorCodeData] = useState([]);
  const [oemErrorCodeId, setOemErrorCodeId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });

  const page = useSelector((state) => state.oemErrorCode.page);
  const totalData = useSelector((state) => state.oemErrorCode.total);
  const limit = useSelector((state) => state.oemErrorCode.limit);
  const totalPages = useSelector((state) => state.oemErrorCode.totalPages);
  const oemErrorCodeList = useSelector((state) => state.oemErrorCode.oemErrorCodes);
  const isLoader = useSelector((state) => state.oemErrorCode.isLoading);

  const getOemErrorCode = useCallback((data = {}) => {
    dispatch({ type: FETCH_OEM_ERROR_CODE, payload: data });
  }, []);

  const getOemErrorCodeDetail = useCallback((id) => {
    dispatch({ type: GET_OEM_ERROR_CODE, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setOemErrorCodeId('');
  };

  const deleteOemErrorCode = useCallback(
    () =>
      dispatch({
        type: DELETE_OEM_ERROR_CODE,
        payload: oemErrorCodeId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getOemErrorCode({ page });
          }
        },
      }),
    [oemErrorCodeId]
  );

  useEffect(() => {
    getOemErrorCode();
  }, []);

  useEffect(() => {
    setAllOemErrorCodeData(
      _.filter(
        oemErrorCodeList,
        (item) =>
          startsWith(_.get(item, 'vendor.name', ''), searchText) ||
          startsWith(_.get(item, 'state.name', ''), searchText) ||
          startsWith(_.get(item, 'code', ''), searchText)
      )
    );
  }, [searchText, oemErrorCodeList]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getOemErrorCode(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getOemErrorCode(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getOemErrorCode(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormOemErrorCode = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="Oem Error Code" />
        <div className="page-content-wrapper scrollable">
          <div className="oemErrorCodeList-page">
            <Card>
              <div className="oemErrorCodeList-page-wrapper">
                <Row className="oemErrorCodeList-search-box">
                  <Col xl={10} lg={9} md={8} className="oemErrorCodeList-search-inputBox">
                    <SearchBox value={searchText} preIcon={<BsSearch />} onChange={(e) => setSearchText(e.target.value)} />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="oemErrorCodeList-search-boxButton">
                    <Button
                      className="oemErrorCodeList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add Oem Error Code
                    </Button>
                  </Col>
                </Row>
                <div className="oemErrorCodeList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Oem Error Code</span>
                              <span className="ico" onClick={() => handleSorting('code', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Vendor Name</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>State Name</span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(allOemErrorCodeData) ? (
                          <tr>
                            <td colSpan={3} className="border-0">
                              <div className="empty-data-block">No Oem Error Code Data</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(allOemErrorCodeData, (item, key) => {
                            return (
                              <>
                                <tr key={`oemErrorCode-${key}`}>
                                  <td>{_.get(item, 'code', '')}</td>
                                  <td>{_.get(item, 'vendor.name', '')}</td>
                                  <td>{_.get(item, 'state.name', '')}</td>
                                  <td>
                                    <span
                                      className="oemErrorCodeList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getOemErrorCodeDetail(_.get(item, 'id', ''));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 />
                                    </span>
                                    <span
                                      className="oemErrorCodeList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setOemErrorCodeId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(allOemErrorCodeData) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                  // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <OemErrorCodeForm onClose={handleCloseFormOemErrorCode} onSuccess={getOemErrorCode} isEdit={isEdit} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="oemErrorCode" onClose={handleCloseDeleteModel} onRemove={deleteOemErrorCode} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default OemErrorCodeList;
